<script lang="ts" setup>
import { useUUID } from '../../../helpers/form-field.js';
import { DatePicker } from '../../Components/index.js';

defineProps<{
  label: string;
  placeholder: string;
  minDate?: Date;
}>();

defineModel<Date>();
const randomId = useUUID();
</script>

<template>
  <y-input-wrapper>
    <label slot="label" :for="randomId">{{ label }}</label>
    <DatePicker :min-date="minDate" :input-id="randomId" :placeholder="placeholder" @update:model-value="(val) => $emit('update:modelValue', val)" />
  </y-input-wrapper>
</template>
